(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7633],{

/***/ 44748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _react_icons_all_files_im_ImArrowDown2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10855);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86314);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1254);






/*** Vendors ***/ /*** components ***/ /*** ========== ***/ /**
 *
 * @param {{
 * imgPosition: "left"|"right";
 * }} props Props for the component
 *
 */ var ImageDescribe = function(param) {
    var properties = param.properties;
    var img_src = properties.img_src, img_height = properties.img_height, img_position = properties.img_position, width = properties.width, height = properties.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mt-8 lg:col-5 lg:mt-0 ".concat(img_position === "left" ? "lg:order-first" : "lg:order-last"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            src: img_src,
            width: width || 445,
            height: height || 624,
            className: "h-full w-full rounded object-cover object-center",
            wrapper: {
                className: "w-full flex items-center justify-center ".concat(img_height || "h-auto")
            }
        })
    });
};
var AccordionImg = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data.wrapper), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " lg:col-7 lg:-mt-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data.content_wrapper), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            data: data.info_list
                        }, typeof data.active != "undefined" ? {
                            defaultActiveKey: data.active
                        } : 0), {
                            icon: {
                                Icon: _react_icons_all_files_im_ImArrowDown2__WEBPACK_IMPORTED_MODULE_5__/* .ImArrowDown2 */ .o,
                                size: 20,
                                className: "p-1 text-gleads-oxfordBlue-700",
                                wrapperSubclass: "shadow rounded-full  bg-white"
                            },
                            accordionClass: (data === null || data === void 0 ? void 0 : data.border) || "border-b border-b-gleads-oxfordBlue-800 mb-0",
                            buttonClass: (data === null || data === void 0 ? void 0 : data.button_class) || "px-0 py-3 lg:py-4 pr-20 font-semibold text-xl",
                            buttonWrapperClass: {
                                open: "bg-transparent",
                                close: "bg-transparent"
                            },
                            buttonContentClass: {
                                open: data.text_color_open && data.text_color_open || "text-gleads-oxfordBlue-800 ",
                                close: data.text_color && data.text_color + " opacity-80" || "text-gleads-oxfordBlue-800 opacity-80"
                            },
                            panelClass: data.panel_class
                        }))
                    }))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageDescribe, {
                    properties: data.img_props
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionImg);


/***/ }),

/***/ 8827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





/**
 * vendor
 */ /** ========== */ var Breadcrumbs = function(param) {
    var data = param.data, color = param.color, hoverColor = param.hoverColor, lastColor = param.lastColor, wrapper = param.wrapper;
    var breadcrumbs = JSON.parse(JSON.stringify(data).split("https://gleads.vn").join("https://gleads.vn"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, wrapper), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-wrap items-center justify-start",
            children: breadcrumbs.map(function(item, index) {
                var last = index + 1 === breadcrumbs.length;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "font-bold",
                    children: !last ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: item === null || item === void 0 ? void 0 : item.url,
                                className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)("inline-block pr-2", color, hoverColor),
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "inline-block  ".concat(color, "  pr-2"),
                                children: "/"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-oxfordBlue inline-block  ".concat(lastColor),
                        children: item === null || item === void 0 ? void 0 : item.title
                    })
                }, index);
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);
Breadcrumbs.propTypes = {
    items: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().array),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    hoverColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    lastColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Breadcrumbs.defaultProps = {
    items: [],
    color: "text-gleads-base",
    hoverColor: "hover:text-gleads-oxfordBlue-500",
    lastColor: ""
}; /** ========== */ 


/***/ }),

/***/ 21971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86314);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






/**
 *
 * @param {{
 * data: {}
 * button: (<Button/>)
 * }} props
 * @returns JSX.Element
 */ var CatalogItem = function(_param) {
    var data = _param.data, button = _param.button, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "data",
        "button"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: props.className ? props.className : "row mb-6 last:mb-0 lg:mb-15 lg:last:mb-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-6 flex items-center justify-center last:mb-0 lg:col-6 lg:mb-0 ".concat(data.image["position"] === "left" ? "lg:order-first" : " lg:order-last"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        src: data.image["src"],
                        alt: data.image["alt"],
                        height: data === null || data === void 0 ? void 0 : data.image["height"],
                        width: data === null || data === void 0 ? void 0 : data.image["width"],
                        className: "",
                        wrapper: {
                            className: "flex items-center"
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-6 flex items-center justify-center last:mb-0 lg:col-6 lg:mb-0 ".concat(data.content["position"] === "left" ? "lg:order-first" : " lg:order-last "),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                as: "h3",
                                className: "mb-6 text-left text-2xl font-bold text-gleads-oxfordBlue-800",
                                children: data.content["title"]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-base text-gleads-basic ".concat(button ? "lg:mb-6" : ""),
                                dangerouslySetInnerHTML: {
                                    __html: data.content["description"]
                                }
                            }),
                            button && /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.cloneElement)(button)
                        ]
                    })
                })
            ]
        })
    });
};
CatalogItem.propTypes = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    button: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().element)
};
CatalogItem.defaultProps = {
    data: {},
    button: null
};
/* harmony default export */ __webpack_exports__["Z"] = (CatalogItem);


/***/ }),

/***/ 34564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_atoms_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89577);






/*** Vendors ***/ /*** components ***/ 
var ModalDialog = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7731), __webpack_require__.e(5204)]).then(__webpack_require__.bind(__webpack_require__, 34589));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34589)
            ];
        }
    },
    ssr: false
});
var ModalBody = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7731), __webpack_require__.e(5204)]).then(__webpack_require__.bind(__webpack_require__, 34589)).then(function(module) {
        return module.ModalBody;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34589)
            ];
        }
    },
    ssr: false
});
var ContactForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(154), __webpack_require__.e(7731), __webpack_require__.e(539)]).then(__webpack_require__.bind(__webpack_require__, 80154));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80154)
            ];
        }
    },
    ssr: false
});
/*** ========== ***/ /**
 *
 * @param {{
 * }} props Props for the component
 *
 */ var ContactButton = function(props) {
    var wrapper = props.wrapper, children = props.children, requestService = props.requestService, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "wrapper",
        "children",
        "requestService"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpenModal = ref[0], setIsOpenModal = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: wrapper === null || wrapper === void 0 ? void 0 : wrapper.className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                onClick: function() {
                    return setIsOpenModal(true);
                }
            }, otherProps), {
                children: children
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, {
                size: "lg",
                isOpen: isOpenModal,
                cancelCallBack: function() {
                    return setIsOpenModal(false);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalBody, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactForm, {
                        className: "py-10 px-4 lg:py-15 lg:px-10",
                        subject: requestService,
                        isLazyLoad: false,
                        callback: function(res) {
                            return setIsOpenModal(false);
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactButton);


/***/ }),

/***/ 1254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63228);
/* harmony import */ var components_atoms_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2728);




/**
 * vendor
 */ /* components
 */ 

var FaqsGroup = function(_param) {
    var data = _param.data, haveTabs = _param.haveTabs, defaultActiveKey = _param.defaultActiveKey, multipleOpen = _param.multipleOpen, icon = _param.icon, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "data",
        "haveTabs",
        "defaultActiveKey",
        "multipleOpen",
        "icon"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        if (Array.isArray(data)) {
            return data === null || data === void 0 ? void 0 : data.map(function(item) {
                return item.name.toLowerCase().split(" ").join("-");
            });
        } else {
            return data === null || data === void 0 ? void 0 : data.data.map(function(item) {
                return item.name.toLowerCase().split(" ").join("-");
            });
        }
    }), listKey = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        listKey[defaultActiveKey]
    ]), active = ref1[0], setActive = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .AccordionContext.Provider */ .S.Provider, {
        value: {
            active: active,
            setActive: setActive
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            icon: icon,
            list: data,
            multipleOpen: multipleOpen,
            buttonClass: props.buttonClass,
            panelClass: props.panelClass
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqsGroup);


/***/ }),

/***/ 17450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86314);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17499);




/*** Vendors ***/ /*** components ***/ /*** ========== ***/ /**
 *
 * @param {{
 * }} props Props for the component
 *
 */ var IntroduceShowMore = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                as: "h2",
                othersClass: "mb-6 lg:mb-10 lg:text-center",
                title: typeof data.title === "string" ? {
                    content: (data === null || data === void 0 ? void 0 : data.title) || "C\xe1c g\xf3i d\u1ECBch v\u1EE5"
                } : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data.title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: data.product_list.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "lg:col-6 ".concat(index < data.product_list.length - 2 && "mb-4 lg:mb-10" || "mb-4 last:mb-0 lg:mb-0"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex h-full flex-col justify-start",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    src: item.img_src,
                                    width: item.width || 540,
                                    height: item.height || 350,
                                    className: " h-full w-full object-cover object-center ",
                                    wrapper: {
                                        className: " mb-4 rounded-xl overflow-hidden  w-full"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "mb-0 text-left",
                                        children: [
                                            item.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.name
                                                }
                                            }),
                                            item.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.prefix
                                            }),
                                            item.fee && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.fee.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "VND"
                                                })
                                            }),
                                            item.des && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.des
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IntroduceShowMore);


/***/ }),

/***/ 11674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




/*** Vendors ***/ /*** components ***/ /*** ========== ***/ /**
 *
 * @param {{
 * }} props Props for the component
 *
 */ var OverBox = function(_param) {
    var wrapper = _param.wrapper, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "wrapper",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, wrapper), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                className: "relative inset-x-0 z-50 -mt-15 h-auto p-6 px-4 lg:-mt-32 lg:p-10 ".concat(className || "")
            }, props), {
                children: children
            }))
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OverBox);


/***/ }),

/***/ 45009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17499);
/* harmony import */ var components_atoms_Description__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9945);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86314);
/* harmony import */ var components_atoms_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89577);




/**
 * vendor
 */ /**
 * components
 */ 



/** ========== */ var PostCard = function(_param) {
    var item = _param.item, aspect = _param.aspect, img = _param.img, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "item",
        "aspect",
        "img"
    ]);
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "group flex h-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative overflow-hidden rounded-t",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            image: item === null || item === void 0 ? void 0 : (ref = item.featuredImage) === null || ref === void 0 ? void 0 : ref.node,
                            alt: item === null || item === void 0 ? void 0 : item.title,
                            width: 375,
                            height: 375,
                            className: "h-full w-full object-cover ".concat(aspect, " transition-all duration-700\n            group-hover:scale-110 group-hover:transform"),
                            wrapper: {
                                className: "w-full relative"
                            }
                        }, img)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-0 left-0 z-10 h-full w-full opacity-0 transition-all duration-300 group-hover:opacity-30"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex flex-1 flex-col justify-between px-4 pt-4 pb-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    as: "h3",
                                    className: "text-xl font-bold leading-relaxed text-gleads-greys-600 transition-colors duration-150 line-clamp-2 hover:text-gleads-oxfordBlue-600 lg:text-gleads-oxfordBlue-700 ".concat((item === null || item === void 0 ? void 0 : item.excerpt) ? "mb-4" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/vi" + item.uri,
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Description__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "mb-6 text-ellipsis text-gleads-greys-500 line-clamp-2",
                                    dangerouslySetInnerHTML: {
                                        __html: item === null || item === void 0 ? void 0 : item.excerpt
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                as: "a",
                                href: "/vi" + (item === null || item === void 0 ? void 0 : item.uri),
                                className: props.seeMoreClass || "inline-block w-max rounded-md bg-gleads-greys-100 p-2 text-sm font-bold transition-colors duration-150 hover:bg-gleads-greys-500 hover:text-white",
                                children: "Xem th\xeam"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);
PostCard.propTypes = {
    item: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object),
    layout: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    aspect: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    img: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
PostCard.defaultProps = {
    item: {},
    layout: "vertical",
    aspect: "aspect-[16/9]",
    img: {}
}; /** ========== */ 


/***/ }),

/***/ 73310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_atoms_Description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9945);



var ServiceCard = function(_param) {
    var data = _param.data, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "data"
    ]);
    var inner = props.inner;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex h-full w-full flex-col items-center justify-start rounded bg-white shadow-[0px_16px_40px_rgba(181,181,181,0.2)] ".concat((inner === null || inner === void 0 ? void 0 : inner.className) || ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full ".concat(data.description ? "mb-4" : ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-4 inline-block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (inner === null || inner === void 0 ? void 0 : inner.iconStyles) || "rounded-full bg-gleads-buttonBlue-100 p-3",
                                children: data === null || data === void 0 ? void 0 : data.icon
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "m-0 text-xl font-semibold ".concat((inner === null || inner === void 0 ? void 0 : inner.titleStyles) || ""),
                            children: data === null || data === void 0 ? void 0 : data.title
                        })
                    ]
                }),
                data.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Description__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "text-sm ".concat((inner === null || inner === void 0 ? void 0 : inner.descriptionStyles) || ""),
                    dangerouslySetInnerHTML: {
                        __html: data.description
                    }
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ServiceCard);


/***/ }),

/***/ 45502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63910);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6644);
/* harmony import */ var _react_icons_all_files_hi_HiOutlineChevronRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45899);




/* eslint-disable react-hooks/exhaustive-deps */ 







function NextArrow(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "g-button-next ".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["btn-next"]), " "),
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiOutlineChevronRight__WEBPACK_IMPORTED_MODULE_7__/* .HiOutlineChevronRight */ .y, {
                size: 20,
                className: "text-red-400"
            })
        })
    });
}
function PrevArrow(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "g-button-prev ".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["btn-prev"]), " "),
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiOutlineChevronRight__WEBPACK_IMPORTED_MODULE_7__/* .HiOutlineChevronRight */ .y, {
                size: 18,
                className: "rotate-180 text-red-400"
            })
        })
    });
}
var NormalSlider = function(_param) {
    var settings = _param.settings, children = _param.children, wrapper = _param.wrapper, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "settings",
        "children",
        "wrapper"
    ]);
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasSetPosition = ref[0], setHasSetPosition = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (sliderRef.current && !hasSetPosition) {
            var ref;
            (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(settings.initialSlide);
            setHasSetPosition(true);
        }
    }, [
        hasSetPosition,
        sliderRef
    ]);
    settings.dotsClass = (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["slick-dots-normal"]);
    settings.appendDots = function(dotList) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            children: dotList.map(function(dot, idx) {
                if (dot.props["className"] === "slick-active") {
                    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                        className: "slick-active",
                        onClick: function() {
                            goToSlide(idx);
                        }
                    });
                } else {
                    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                        className: "",
                        onClick: function() {
                            goToSlide(idx);
                        }
                    });
                }
            })
        });
    };
    settings.customPaging = function(i) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            children: i
        });
    };
    if (settings.arrows) {
        if (!settings.nextArrow) {
            settings.nextArrow = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextArrow, {});
        }
        if (!settings.prevArrow) {
            settings.prevArrow = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevArrow, {});
        }
    }
    var goToSlide = function(index) {
        sliderRef.current && sliderRef.current.slickGoTo(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            className: "relative"
        }, wrapper), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                ref: sliderRef,
                dots: true,
                arrows: false,
                className: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .A)((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["g-slider-normal"]), props.autoHeight ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["g-slider-normal-auto-h"]) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["g-slider-normal-full-h"]), props.customClass)
            }, settings), {
                children: children && react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children) > 0 && react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(element, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(element, {
                            // ref: createRef(idx),
                            className: "mx-auto ".concat(!settings.adaptiveHeight && "h-full")
                        })
                    });
                })
            }))
        }))
    });
};
NormalSlider.propTypes = {
    settings: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().object),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().any),
    wrapper: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().object)
};
NormalSlider.defaultProps = {
    settings: {},
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
    wrapper: {}
};
/* harmony default export */ __webpack_exports__["default"] = (NormalSlider);


/***/ }),

/***/ 86400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63910);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);




/* eslint-disable react-hooks/exhaustive-deps */ 





var Preview = function(_param) {
    var settings = _param.settings, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "settings",
        "children"
    ]);
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
    // sliderRef.current.slickGoTo(currentIndex);
    }, [
        currentIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                ref: sliderRef,
                waitForAnimate: false,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["g-slider-preview"]),
                dotsClass: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["slick-dots-preview"]),
                beforeChange: function(current, next) {
                    setCurrentIndex(Math.ceil(next));
                },
                appendDots: function(dots) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex items-center justify-center",
                            children: [
                                " ",
                                dots,
                                " "
                            ]
                        })
                    });
                },
                customPaging: function(i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: Math.ceil(i) === currentIndex ? "slick-active" : "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            children: i + 1
                        })
                    });
                }
            }, settings), {
                children: children && react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children) > 0 && react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(element, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(element, {
                            ref: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)(idx),
                            className: "mx-auto ".concat(!settings.adaptiveHeight && "h-full")
                        })
                    });
                })
            }))
        })
    });
};
Preview.propTypes = {
    settings: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().object),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().any)
};
Preview.defaultProps = {
    settings: {},
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
};
/* harmony default export */ __webpack_exports__["Z"] = (Preview);


/***/ }),

/***/ 59791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63910);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);



/* eslint-disable react-hooks/exhaustive-deps */ 





var Simple = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function Simple(props, ref) {
    var settings = props.settings, children = props.children, mouseWheel = props.mouseWheel;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), parentElement = _$ref[0], setParentElement = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), sliderElement = _$ref1[0], setSliderElement = _$ref1[1];
    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            slider: sliderElement === null || sliderElement === void 0 ? void 0 : sliderElement.innerSlider,
            goToSlide: function goToSlide(index) {
                sliderElement && sliderElement.slickGoTo(index);
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!parentElement) {
            return;
        }
        if (parentElement && mouseWheel) {
            //only use mouse scroll in desktop screen
            parentElement.addEventListener("wheel", function(e) {
                return handleScroll(e);
            });
        }
        return function() {
            parentElement.removeEventListener("wheel", function(e) {
                return handleScroll(e);
            });
        };
    }, [
        parentElement,
        mouseWheel
    ]);
    var handleScroll = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.deltaY > 0) {
            sliderElement && sliderElement.slickNext();
        } else if (e.deltaY < 0) {
            sliderElement && sliderElement.slickPrev();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: function(el) {
                if (!el) return;
                setParentElement(el);
            },
            className: "relative h-full w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["g-slider-simple"])
            }, settings), {
                ref: function(el) {
                    if (!el) return;
                    setSliderElement(el);
                },
                children: children
            }))
        })
    });
});
Simple.propTypes = {
    settings: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    mouseWheel: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
Simple.defaultProps = {
    settings: {},
    mouseWheel: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Simple);


/***/ }),

/***/ 66138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63910);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);




/* eslint-disable react-hooks/exhaustive-deps */ 





/**
 *
 * @param {{
 * parentEl: createRef() || useRef()
 * }} props
 * @returns
 */ var Vertical = function(_param) {
    var parentEl = _param.parentEl, useMouseWheel = _param.useMouseWheel, settings = _param.settings, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "parentEl",
        "useMouseWheel",
        "settings",
        "children"
    ]);
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    if (settings.dots) {
        settings.appendDots = function(dotList) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: dotList.map(function(dot, idx) {
                    if (dot.props["className"] === "slick-active") {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                            className: "slick-active ".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["slick-active"])),
                            onClick: function() {
                                goToSlide(idx);
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                            className: "",
                            onClick: function() {
                                goToSlide(idx);
                            }
                        });
                    }
                })
            });
        };
        settings.customPaging = function(i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                children: i
            });
        };
        if (settings.dotClasses) {
            var dotStyles = settings.dotClasses;
            settings.appendDots = function(dotList) {
                //with dot styles
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: dotList.map(function(dot, idx) {
                        if (dot.props["className"] === "slick-active") {
                            var ref, ref1, ref2, ref3;
                            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                                className: settings.dotPosition === "left" || settings.dotPosition === "right" ? "slick-active ".concat((ref = dotStyles.vertical) === null || ref === void 0 ? void 0 : ref.normal, "  ").concat((ref1 = dotStyles.vertical) === null || ref1 === void 0 ? void 0 : ref1.active) : "slick-active ".concat((ref2 = dotStyles.horizontal) === null || ref2 === void 0 ? void 0 : ref2.normal, " ").concat((ref3 = dotStyles.horizontal) === null || ref3 === void 0 ? void 0 : ref3.active),
                                onClick: function() {
                                    goToSlide(idx);
                                }
                            });
                        } else {
                            var ref4, ref5;
                            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(dot, {
                                className: settings.dotPosition === "left" || settings.dotPosition === "right" ? "".concat((ref4 = dotStyles.vertical) === null || ref4 === void 0 ? void 0 : ref4.normal) : "".concat((ref5 = dotStyles.horizontal) === null || ref5 === void 0 ? void 0 : ref5.normal),
                                onClick: function() {
                                    goToSlide(idx);
                                }
                            });
                        }
                    })
                });
            };
            settings.customPaging = function(i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {});
            };
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!parentEl.current) {
            return;
        }
        if (parentEl && parentEl.current && useMouseWheel) {
            //only use mouse scroll in desktop screen
            parentEl.current.addEventListener("wheel", function(e) {
                return handleScroll(e);
            });
        }
        return function() {
            parentEl.current.removeEventListener("wheel", function(e) {
                return handleScroll(e);
            });
        };
    }, [
        useMouseWheel,
        parentEl
    ]);
    var handleScroll = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.deltaY > 0) {
            sliderRef.current && sliderRef.current.slickNext();
        } else if (e.deltaY < 0) {
            sliderRef.current && sliderRef.current.slickPrev();
        }
    };
    var goToSlide = function(index) {
        sliderRef.current && sliderRef.current.slickGoTo(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative h-full w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["g-slider-vertical"])
            }, settings), {
                ref: sliderRef,
                children: children && react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children) > 0 && react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(element, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(element, {
                            ref: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)(idx),
                            className: "mx-auto ".concat(!settings.adaptiveHeight && "h-full")
                        })
                    });
                })
            }))
        })
    });
};
Vertical.propTypes = {
    parentEl: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().any),
    settings: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().object),
    useMouseWheel: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().any)
};
Vertical.defaultProps = {
    parentEl: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)(null),
    settings: {},
    useMouseWheel: true,
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
};
/* harmony default export */ __webpack_exports__["Z"] = (Vertical);


/***/ }),

/***/ 21258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Simple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59791);
/* harmony import */ var _Preview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86400);
/* harmony import */ var _Vertical__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66138);
/* harmony import */ var _Normal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45502);




/* eslint-disable react-hooks/exhaustive-deps */ 

// import dynamic from "next/dynamic";



// import NormalSlider from "./Normal";

// const Simple = dynamic(() => import("./Simple"));
// const Preview = dynamic(() => import("./Preview"));
// const Vertical = dynamic(() => import("./Vertical"));
// const Normal = dynamic(() => import("./Normal"));
/**
 *
 * @param {{
 * type: "simple"|"normal"|"preview"|"vertical";
 * }} props Props for the component
 *
 */ var Slider = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function Slider(_param, ref) {
    var children = _param.children, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children",
        "type"
    ]);
    var renderSlider = function() {
        switch(type){
            case "normal":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Normal__WEBPACK_IMPORTED_MODULE_5__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    ref: ref
                }, props), {
                    children: children
                }));
            case "vertical":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Vertical__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    ref: ref
                }, props), {
                    children: children
                }));
            case "preview":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Preview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    ref: ref
                }, props), {
                    children: children
                }));
            case "simple":
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Simple__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    ref: ref
                }, props), {
                    children: children
                }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: renderSlider()
    });
});
Slider.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
Slider.defaultProps = {
    type: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Slider);


/***/ }),

/***/ 50530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40872);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_atoms_Icon_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25081);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86314);




/*** Vendors ***/ /*** components ***/ /*** ========== ***/ var listButton = [
    {
        icon: components_atoms_Icon_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_1__/* .FaFacebookF */ .t,
        backgroundColor: "#1877f2",
        url: "https://www.facebook.com/gleadsvn"
    }, 
];
/**
 *
 * @param {{
 * }} props Props for the component
 *
 */ var SocialList = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            listButton.map(function(item, index) {
                var TagName = item.icon;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: item.url,
                    rel: "nofollow",
                    style: {
                        backgroundColor: item.backgroundColor,
                        width: props.width || "34px",
                        height: props.height || "34px"
                    },
                    className: props.className || "mr-4 inline-flex cursor-pointer rounded-full p-0 align-middle last:mr-0 hover:brightness-110",
                    target: "blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagName, {
                        style: {
                            minWidth: "33px"
                        },
                        width: 16,
                        height: 16,
                        size: props.size,
                        color: "#fff",
                        className: "m-auto"
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://zalo.me/536303807395273679",
                rel: "nofollow",
                style: {
                    backgroundColor: "#1da1f2",
                    width: props.width || "34px",
                    height: props.height || "34px"
                },
                className: props.className || "mr-4 inline-flex cursor-pointer rounded-full p-0 align-middle last:mr-0 hover:brightness-110",
                target: "blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    style: {
                        minWidth: "33px"
                    },
                    width: 16,
                    height: 16,
                    src: "/assets/icons/zalo-chat.svg",
                    wrapper: {
                        className: "w-full h-full flex justify-center items-center"
                    },
                    color: "#fff",
                    className: "h-full w-full"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialList);


/***/ }),

/***/ 85038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaFacebookF.js
var FaFacebookF = __webpack_require__(62916);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaLinkedinIn.js
var FaLinkedinIn = __webpack_require__(57951);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(40872);
;// CONCATENATED MODULE: ./components/molecules/SocialShare/function.js

var handleOnFacebookShare = function(e, _param) {
    var params = (0,src_extends/* default */.Z)({}, _param);
    e.preventDefault();
    var width = 650, height = 450;
    var facebookWindow = window.open("https://www.facebook.com/sharer/sharer.php?u=" + ((params === null || params === void 0 ? void 0 : params.url) || document.URL) + (params.quote ? "&quote=" + params.quote : ""), "facebook-popup", "height=450,width=650", "top=" + (screen.height / 2 - height / 2) + "", "left=" + (screen.width / 2 - width / 2) + "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes");
    if (facebookWindow.focus) {
        facebookWindow.focus();
    }
    return false;
};

var handleOnTwitterShare = function(e, _param) {
    var params = _extends({}, _param);
    var width = 650, height = 450;
    var twitterWindow = window.open("https://twitter.com/share?url=" + ((params === null || params === void 0 ? void 0 : params.url) || document.URL) + (params.title ? "&text=" + params.title : ""), "twitter-popup", "height=350,width=600");
    if (twitterWindow.focus) {
        twitterWindow.focus();
    }
    return false;
};

var handleOnLinkedShare = function(e, _param) {
    var params = (0,src_extends/* default */.Z)({}, _param);
    var width = 650, height = 450;
    e.preventDefault();
    // let LinkedinWindow = window.open(
    //   "https://www.linkedin.com/sharer/sharer.php?u=" +
    //     (params?.url || document.URL) +
    //     (params.title ? "&title=" + params.title : ""),
    //   "linkedin-popup",
    //   "height=350,width=600"
    // );
    var LinkedinWindow = window.open("https://www.linkedin.com/sharing/share-offsite?url=" + ((params === null || params === void 0 ? void 0 : params.url) || document.URL) + (params.title ? "&title=" + params.title : ""), "linkedin-popup", "height=350,width=600");
    if (LinkedinWindow.focus) {
        LinkedinWindow.focus();
    }
    return false;
};


;// CONCATENATED MODULE: ./components/molecules/SocialShare/SocialShare.js







var listButton = [
    {
        name: "facebook",
        icon: FaFacebookF/* FaFacebookF */.t,
        backgroundColor: "#1877f2",
        shareFunc: handleOnFacebookShare
    },
    // {
    //   name: "twitter",
    //   icon: FaTwitter,
    //   backgroundColor: "#1da1f2",
    //   shareFunc: handleOnTwitterShare,
    // },
    {
        name: "linkedIn",
        icon: FaLinkedinIn/* FaLinkedinIn */.B,
        backgroundColor: "#0077b5",
        shareFunc: handleOnLinkedShare
    }, 
];
function SocialShare(param) {
    var iconWidth = param.iconWidth, iconHeight = param.iconHeight, title = param.title, titleClass = param.titleClass, iconCLass = param.iconCLass, socialList = param.socialList, params = param.params;
    var SocialButton = function(param) {
        var data = param.data, width = param.width, height = param.height;
        switch(data.name){
            case "facebook":
                data = (0,_object_spread/* default */.Z)({}, data, listButton.find(function(x) {
                    return x.name === "facebook";
                }));
                break;
            // case "twitter":
            //   data = { ...data, ...listButton.find((x) => x.name === "twitter") };
            //   break;
            case "linkedIn":
                data = (0,_object_spread/* default */.Z)({}, data, listButton.find(function(x) {
                    return x.name === "linkedIn";
                }));
                break;
            default:
                break;
        }
        var CustomTag = data.icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: function(e) {
                return data.shareFunc(e, data === null || data === void 0 ? void 0 : data.title, data === null || data === void 0 ? void 0 : data.url);
            },
            style: {
                width: (data === null || data === void 0 ? void 0 : data.width) || width,
                height: (data === null || data === void 0 ? void 0 : data.height) || height,
                backgroundColor: data === null || data === void 0 ? void 0 : data.backgroundColor
            },
            className: "hover:brightness-110  ".concat((data === null || data === void 0 ? void 0 : data.styles) || "mb-0 mr-2 rounded-full p-0 lg:mb-2"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTag, {
                    width: 16,
                    height: 16,
                    color: "#fff",
                    className: "m-auto"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "capitalize",
                    children: data === null || data === void 0 ? void 0 : data.text
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block ".concat(titleClass),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "social",
                className: "\n           sticky flex items-end lg:items-start ".concat(iconCLass || ""),
                children: socialList && socialList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: socialList.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {
                            data: item,
                            width: iconWidth,
                            height: iconHeight
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: listButton.map(function(item, index) {
                        var CustomTag = item.icon;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                return item.shareFunc(e, (0,_object_spread/* default */.Z)({}, params));
                            },
                            style: {
                                backgroundColor: item.backgroundColor,
                                width: iconWidth,
                                height: iconHeight
                            },
                            className: "mb-0 mr-2 rounded-full p-0 hover:brightness-110 lg:mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTag, {
                                width: 16,
                                height: 16,
                                color: "#fff",
                                className: "m-auto"
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 83670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10797);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56727);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71270);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var WorkingProcess = function(_param) {
    var data = _param.data, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "data"
    ]);
    // const [explainList, setExplainList] = useState([1]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), explainList = ref[0], setExplainList = ref[1];
    var explainAll = function(start, end, explained) {
        while(start <= end){
            explained[start] = 1;
            start += 1;
        }
        setExplainList(explained);
    };
    var collapseAll = function(start, end, explained) {
        while(start <= end){
            explained[start] = -1;
            start += 1;
        }
        setExplainList(explained);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: data && Array.isArray(data) && data.map(function(item, index) {
            if (item.content && item.content != "") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure */ .pJ, {
                    children: function(param) {
                        var open = param.open;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)("relative mb-4 cursor-pointer lg:mb-6", (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), "".concat(explainList[index] && explainList[index] !== -1 ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().explained) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collapsed))),
                                onClick: function() {
                                    var explained = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(explainList);
                                    if (explained[index] && explained[index] !== -1) {
                                        explained[index] = -1;
                                        collapseAll(index + 1, data.length - 1, explained);
                                    } else {
                                        explained[index] = 1;
                                        explainAll(0, index - 1, explained);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Button */ .pJ.Button, {
                                        className: "relative flex w-full items-center justify-between space-x-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center justify-start space-x-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["content-icon"]),
                                                        children: item.icon
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-gleads-oxfordBlue-800 ".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["content-text"])),
                                                        children: item.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["explain-button"]), "".concat(explainList[index] && explainList[index] !== -1 && "before:rotate-90"))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .uT, {
                                        as: "div",
                                        className: "relative",
                                        show: explainList[index] && explainList[index] !== -1,
                                        enter: "transition-all duration-600 linear",
                                        enterFrom: "transform max-h-0 h-0 opacity-50",
                                        enterTo: "transform max-h-[400px] h-fit opacity-100",
                                        leave: "transition-all duration-150 linear",
                                        leaveFrom: "transform max-h-[400px] opacity-100",
                                        leaveTo: "transform max-h-0 opacity-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Panel */ .pJ.Panel, {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().panel),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: item.content
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        });
                    }
                }, "process-item-".concat(index));
            } else {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,common_functions__WEBPACK_IMPORTED_MODULE_1__/* .classNames */ .A)("relative mb-4 lg:mb-6", (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collapsed)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex w-full items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start space-x-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["content-icon"]),
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["content-text"]),
                                    children: item.name
                                })
                            ]
                        })
                    })
                }, "process-item-".concat(index));
            }
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (WorkingProcess);


/***/ }),

/***/ 71270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkingProcess_container___rfyt","explained":"WorkingProcess_explained__FQd_z","collapsed":"WorkingProcess_collapsed__9oNLq","content-icon":"WorkingProcess_content-icon__V9iy5","content-text":"WorkingProcess_content-text__V6nsq","explain-button":"WorkingProcess_explain-button__4csR7","panel":"WorkingProcess_panel__8Y7JT"};

/***/ })

}]);